import { SECURE_BROWSER_ERROR, VERIFIED_ACCESS_KIOSK_ERROR } from './secureBrowserActions';

const defaultState = {
    secureBrowserError: null,
    verifiedAccessKioskError: null,
};

const secureBrowserReducer = (state = defaultState, action) => {
    switch (action.type) {
        case SECURE_BROWSER_ERROR: {
            return {
                ...state,
                secureBrowserError: action.error,
            };
        }
        case VERIFIED_ACCESS_KIOSK_ERROR: {
            return {
                ...state,
                verifiedAccessKioskError: action.error,
            };
        }
        default:
            return state;
    }
};

export default secureBrowserReducer;
